import { render, staticRenderFns } from "./GiftVoucher_history.vue?vue&type=template&id=cc18468e&"
import script from "./GiftVoucher_history.vue?vue&type=script&lang=js&"
export * from "./GiftVoucher_history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports